import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form, Button, Container, Card, Alert, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

const AcceptInvitationPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError(t('acceptInvitationPage.errors.mismatch'));
            return;
        }
        if (password.length < 8) {
            setError(t('acceptInvitationPage.errors.tooShort'));
            return;
        }

        setIsLoading(true);
        setError(null);
        setSuccess(null);

        try {
            await api.post(`/users/accept-invitation/${token}`, { password });
            setSuccess(t('acceptInvitationPage.success'));
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            setError(err.response?.data?.message || t('acceptInvitationPage.errors.failed'));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <Card style={{ width: '100%', maxWidth: '400px' }}>
                <Card.Body>
                    <h2 className="text-center mb-4">{t('acceptInvitationPage.title')}</h2>
                    <p className="text-center mb-4">{t('acceptInvitationPage.subtitle')}</p>
                    {error && <Alert variant="danger">{error}</Alert>}
                    {success && <Alert variant="success">{success}</Alert>}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="password">
                            <Form.Label>{t('acceptInvitationPage.passwordLabel')}</Form.Label>
                            <Form.Control
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                disabled={isLoading || success}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="confirmPassword">
                            <Form.Label>{t('acceptInvitationPage.confirmPasswordLabel')}</Form.Label>
                            <Form.Control
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                disabled={isLoading || success}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="w-100" disabled={isLoading || success}>
                            {isLoading ? <><Spinner as="span" animation="border" size="sm" /> {t('acceptInvitationPage.creatingButton')}</> : t('acceptInvitationPage.createButton')}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default AcceptInvitationPage;
